import { Component, OnInit } from '@angular/core';
import { DwAction, DwActionButtonComponent, DwActionFunc, DwActionPreference, DwActionType, DwComponent, DwComponentType, DwDecoratorType, DwFilterItemBase, DwFilterType, DwGridActionConfig, DwMenuService, DwMetaDataFilterConfigData, DwMetaDataFilterService, DwMetaDataFilterStateService, DwOperator, DwQueryHelper, DwUiConfigContextBase, getParameterByName } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames, FlightSchoolOrganizationEntity, PilotExaminerEntity } from '../../../../meta-data/app-meta-data.service';
import { Router } from '@angular/router';
import { SchoolTaskDefinition, SchoolTaskService } from '../../services/school-task-service.service';
import { SchoolRepositoryService } from '../../services/school-repository.service';

@DwAction<DwGridActionConfig>({
  keyName: 'school-task-filter-action',
  display: 'School Task Filter',
  actionType: DwActionType.gridAction,
  decoratorType: DwDecoratorType.component,
  //configComponent: DwGridQuickSearchConfigComponent,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.CheckRideRequest,
  allowOnce: true
})
@Component({
  selector: 'app-school-task-filter',
  template: `
      <div class="pull-right">
        <div class="dw-chip" [hidden]="!showChip">
            <div class="dw-chip-label-with-remove no-wrap">{{taskText}}</div>
            <div class="dw-chip-icon" (click)="clearItem()"><i class="fa fa-times-circle"></i></div>
        </div>
      </div>
  `
})
export class SchoolTaskFilterComponent implements DwActionButtonComponent {

  showChip: boolean = false;
  actionPreference: DwActionPreference<any, any>;
  actionContext?: DwUiConfigContextBase;
  taskDef: SchoolTaskDefinition;

  taskText = '?????';
  constructor(private schoolTaskService: SchoolTaskService,
    private router: Router,
    private schoolRepositoryService: SchoolRepositoryService,
    private dwFilterStateService: DwMetaDataFilterStateService
  ) {


  }
  clearItem() {
    this.showChip = false;

    this.clearFilter();
  }

  setupComponent() {
    const filterTask = getParameterByName(this.router, 'filter');

    if (!filterTask) {
      return;
    }

    this.taskDef = this.schoolTaskService.SchoolTaskDefinitions.find(t => t.taskType === filterTask);

    if (!this.taskDef) {
      return;
    }

    this.taskText = `Checkrides ${this.taskDef.titleTextSuffix}`;
    this.showChip = true;

    // Don't show any results until we have loaded the school data
    this.applyFilters(this.buildFilter('CheckRideRequestId', [-1], DwFilterType.In));

    this.schoolRepositoryService.getCurrentFlightSchoolStats(true)
      .subscribe((flightSchool) => {
        this.setupFilter(flightSchool);
      });
  }

  setupFilter(flightSchool: FlightSchoolOrganizationEntity) {
    const scheuledCheckrides = flightSchool.CheckRideRequest.filter((checkride) => this.schoolTaskService.isScheduledCheckride(checkride));

    const currentCheckrideRequests = scheuledCheckrides.filter((checkride) => this.taskDef.filterFunc(checkride));

    const checkrideIds = currentCheckrideRequests.map((checkride) => checkride.CheckRideRequestId);

    if (checkrideIds.length == 0) {
      checkrideIds.push(-1);
    }

    const newFilter = this.buildFilter('CheckRideRequestId', checkrideIds, DwFilterType.In);

    this.applyFilters(newFilter);
  }

  clearFilter() {
    this.applyFilters({});
  }

  private applyFilters(newFilter: any) {
    const allFilters = this.dwFilterStateService.state.filters || {};

    allFilters['GroupSchoolTaskFilter'] = newFilter;

    const preserveFilters = {};

    preserveFilters['GroupSchoolTaskFilter'] = newFilter;

    console.log('Applying filters', newFilter);

    this.dwFilterStateService?.setFilters(allFilters, null, null, true, preserveFilters);
  }

  private buildFilter(attrName: string, value: any, filterType: DwFilterType): any {
    const qh = new DwQueryHelper();

    const filterTypeKey = qh.convertFilterType(filterType);
    const filter: any = {
      Op: DwOperator.And
    };

    // Use the display attribute name which works for text as well as lookups
    const attrFilter: any = filter[attrName] = {};

    //attrFilter.Prefix = attr.RelationPrefix;
    attrFilter[filterTypeKey] = value;

    return filter;
  }

}
